"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333mboIcon = createIcon({
  displayName: "_333mboIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m48.144028-16.884937v31.433107h288.253732l.00139 281.04594h31.4331l-.00138-281.04594h273.77462v-31.433107h-273.77462l.00138-280.985173h-31.4331l-.00139 280.985173z"
        transform="matrix(.70710678 .70710678 -.70710678 .70710678 0 0)"
        fill="currentColor"
      />
      <path
        d="m131.75977 19.585938-28.28321 28.283203 28.28516 28.283203 28.2832-28.283203zm39.74023 39.453124-28.28516 28.285157 28.28516 28.283201 28.2832-28.283201zm213.13672.716797c-85.55103 0-109.5613 57.069781-116.12695 126.179691l125.89062-125.888675c-3.12431-.170352-6.33613-.291016-9.76367-.291016zm71.38476 25.708985-162.69336 162.691406 162.81641 162.81641c21.14852-37.59994-9.15491-104.73272-12.77734-161.05469 3.47947-54.10324 38.77285-126.5026 12.65429-164.453126zm-244.85351 13.097656-28.28516 28.2832 28.28516 28.28516 28.2832-28.28516zm-158.60547.216797-28.283203 28.283203 28.283203 28.28516 28.285156-28.28516zm39.742188 39.455083-28.285157 28.28515 28.285157 28.2832 28.285152-28.2832zm39.666012 39.53124-28.28515 28.28516 28.28515 28.2832 28.28321-28.2832zm-.32226 75.80274-28.28321 28.28516 28.28321 28.2832 28.28515-28.2832zm-39.599612 39.59961-28.283203 28.28125 28.285156 28.28516 28.283199-28.28321zm175.876952 16.625c5.27797 66.63948 25.74044 127.53327 104.63867 130.28711 9.31568.3251 17.43024-.00976 25.00782-.64063zm-56.86523 22.74805-28.28516 28.2832 28.28516 28.28516 28.28515-28.28516zm-158.609378.22265-28.283203 28.28516 28.283203 28.2832 28.285156-28.2832zm119.011718 39.375-28.2832 28.28321 28.28515 28.2832 28.28125-28.28125zm-39.60156 39.60547-28.28321 28.28125 28.28516 28.28516 28.28125-28.28321z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333mboIcon;
